import Cookies from 'js-cookie';

import { Config } from '@edelman/providers';
import { OnSubmitNewsletterData } from '@edelman/ui';
import { publish } from '@edelman/utils';

// Cookie handling
const onCookieNotificationAccept = async () => {
  console.log('Cookies Accepted');
  Cookies.set('cookies_accepted', true, { path: '/' });
  Cookies.set('show_cookie_banner', false, { path: '/' });
  publish('cookiesAccepted', { cookiesAccepted: true });
};
const onCookieNotificationReject = async () => {
  console.log('Cookies Rejected');
  Cookies.set('cookies_accepted', false, { path: '/' });
  Cookies.set('show_cookie_banner', false, { path: '/' });
};

// Newsletter submit callback
const onNewsletterSubmit = async (data: OnSubmitNewsletterData) => console.log(data);

export const appConfig: Config = {
  appName: 'default',
  onCookieNotificationAccept,
  onCookieNotificationReject,
  onNewsletterSubmit,
};
